export function compactObject(value) {
  return Object.entries(value).reduce((result, [key, entryValue]) => {
    if (entryValue !== undefined) {
      result[key] = entryValue;
    }
    return result;
  }, {});
}
